import { call, put } from "redux-saga/effects";
import { mapTaxRatesToBoxes } from "../api";
import { checkResponse } from "store/utils";
import { renderErrorMessage } from "utils/render-error-message";
import { turnMessageOn } from "store/app/actions";
import { logoutRequest } from "store/auth/actions";
import { MessageData } from "store/app/types";
import { mapTaxRatesToBoxesFailure, setTaxRatesToBoxesMapping } from "../actions";

export function* mapTaxRatesToBoxesSaga(action: any) {
  try {
    const { orgUuid, returnTypeId } = action.payload;

    const response = yield call(mapTaxRatesToBoxes, orgUuid, returnTypeId);

    const err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(setTaxRatesToBoxesMapping(response?.data?.mapping));
    
  } catch (error: any) {
        const message: MessageData | null = renderErrorMessage(error);
        if (message) {
          yield put(turnMessageOn(message));
        } else {
          yield put(logoutRequest());
        }
        yield put(mapTaxRatesToBoxesFailure());
  }

}
